import React, { useState, useEffect, useRef } from 'react';

const SeasonSelector = ({ seasons = [], selectedSeason, onSeasonSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSeasonSelect = (season) => {
    if (!season) return;
    onSeasonSelect(season);
    setIsOpen(false);
    setSearchText('');
  };

  const filteredSeasons = seasons.filter(season => {
    // Safely handle possible undefined or null values
    const seasonName = season?.SeasonName || '';
    const searchValue = searchText?.toLowerCase() || '';
    return seasonName.toString().toLowerCase().includes(searchValue);
  });

  // If no seasons are provided, render nothing
  if (!Array.isArray(seasons) || seasons.length === 0) return null;

  return (
    <div id="seasonBox" className="seasonFilter__iteam" ref={dropdownRef}>
      <div className={`customSelecBox2 ${isOpen ? 'openSBox' : ''}`}>
        <div className="cSBDisplay" onClick={() => setIsOpen(!isOpen)}>
          {selectedSeason?.SeasonName || "Select Season"}
        </div>
        {isOpen && (
          <div className={`cSBList2 ${isOpen ? 'active' : ''}`}>
            <div className="cSBList2Search">
              <input 
                type="text" 
                placeholder="Search.." 
                className=""
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
            {filteredSeasons.map((season) => (
              <div
                key={season.SeasonID}
                className="cSBList2Items"
                onClick={() => handleSeasonSelect(season)}
              >
                {season.SeasonName}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SeasonSelector;